import styled from "styled-components";

export const NavbarSindicoContainer = styled.div`
  height: 72px;
  background-color: white;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #d1d1d1;
  margin-bottom: 80px;
  position: fixed;
  z-index: 2;
  padding: 0 8px 0 16px;
`;

export const ButtonMenuSandwitch = styled.button`
  background-color: transparent;
  border: none;

  &:hover {
    opacity: 0.8;
  }
`;
